import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Smartphone, Laptop, TabletSmartphone, Tv, Gamepad2, Camera, Watch, Headphones, WashingMachine, Cable, Package, Sofa } from "lucide-react";
import { CATEGORIES } from "@/lib/catalog";
import { useLang } from "@/lib/i18n";

const ICONS = { Smartphone, Laptop, TabletSmartphone, Tv, Gamepad2, Camera, Watch, Headphones, WashingMachine, Cable, Package, Sofa };

export const CategoryIcon = ({ name, className }) => {
  const Ico = ICONS[name] || Package;
  return <Ico className={className} />;
};

export const CategoryGrid = () => {
  const { t, label } = useLang();
  const navigate = useNavigate();

  return (
    <section id="categories" className="vlx-container scroll-mt-24 py-14 lg:py-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="font-display text-sm font-bold uppercase tracking-widest text-brand">{t("explore")}</p>
          <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-brand-navy sm:text-4xl lg:text-5xl">
            {t("find_device")}
          </h2>
        </div>
        <span className="hidden items-center gap-1.5 text-sm font-semibold text-brand sm:inline-flex">
          {t("categories_count")} <ArrowRight className="h-4 w-4" />
        </span>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            data-testid={`category-card-${c.id}`}
            onClick={() => navigate(`/valuate?category=${c.id}`)}
            className="vlx-lift group flex flex-col overflow-hidden rounded-2xl border border-slate-100 bg-gradient-to-br from-[#EDF3FB] to-[#E9F2EC] text-left shadow-[0_2px_10px_rgba(13,71,161,0.05)] hover:shadow-[0_14px_34px_rgba(13,71,161,0.14)]"
          >
            <div className="relative flex h-32 items-center justify-center bg-[#E8F0FE] p-3 sm:h-40">
              <img
                src={c.image}
                alt=""
                loading="lazy"
                className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 border-t border-white/70 bg-[#E8F0FE] px-4 py-3">
              <p className="font-display text-sm font-semibold leading-tight text-brand-navy sm:text-[15px]">
                {label("categories", c.id)}
              </p>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-brand shadow-sm transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-brand group-hover:text-white">
                <ArrowRight className="h-4 w-4" />
              </span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};
